// extracted by css-extract-rspack-plugin
export default {"cls1":"WhoCanSeePost-cls1_TL9","cls2":"WhoCanSeePost-cls2_CqJ WhoCanSeePost-cls1_TL9"};